import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { useWindowSize } from 'react-use';
import { useLockBodyScrollVertical } from '@hooks';
import {
    MobileProductSlider,
    ProductCarousel,
    ProductDetail,
} from '@components/products';

const Product = ({ product }) => {
    const scrollRef = useRef();
    const { width } = useWindowSize();
    const [isZoomed, setIsZoomed] = useState(false);
    useLockBodyScrollVertical(isZoomed);
    const scrollTop = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    };

    const toggleZoom = () => {
        scrollTop();
        setIsZoomed(!isZoomed);
    };

    return (
        <ProductWrapper ref={scrollRef} isZoomed={isZoomed}>
            <ProductCarousel
                product={product}
                toggleZoom={toggleZoom}
                isZoomed={isZoomed}
            />
            <MobileProductSlider
                product={product}
                toggleZoom={toggleZoom}
                isZoomed={isZoomed}
            />
            <ProductDetail
                isDesktop={width > 1024}
                product={product}
                onProductZoom={isZoomed}
            />
        </ProductWrapper>
    );
};
const ProductWrapper = styled.section`
    display: grid;
    grid-template-columns: 51% 49%;
    margin: 0 auto;
    overflow-x: scroll;
    max-height: 100vh;

    @media (max-width: 1024px) {
        grid-template-columns: 1fr;
        max-height: unset;
        overflow-x: unset;
        margin-top: ${({ isZoomed }) => (isZoomed ? '0' : '60px')};
    }
`;
export default Product;
